// utils/handleCancelSubscriptionAdmin.js
import { doc, updateDoc, deleteField, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

/**
 * Admin can cancel any user's subscription.
 * Requires Firestore rules allowing admin role.
 */
export const handleCancelSubscriptionAdmin = async ({
      targetUid,      // jiska cancel karna hai
      adminUid,       // optional (logging)
      setLoading,     // optional
      onDone,         // optional
      onError,        // optional
      askConfirm = true, // optional
}) => {
      try {
            if (!targetUid) throw new Error("Target UID missing");

            if (askConfirm) {
                  const confirmed = window.confirm(
                        `Cancel subscription for user: ${targetUid}?`
                  );
                  if (!confirmed) return { ok: false, cancelled: false };
            }

            setLoading?.(true);

            const userRef = doc(db, "users", targetUid);

            await updateDoc(userRef, {
                  subscriptions: "cancel_admin",
                  planDetails: deleteField(),
                  isPremium: false,

                  subscriptionMessage: "Your subscription has been cancelled by admin.",

                  // audit fields
                  cancelledByRole: "admin",
                  cancelledAt: serverTimestamp(),
            });

            onDone?.();
            return { ok: true };
      } catch (err) {
            console.error("handleCancelSubscriptionAdmin error:", err);
            onError?.(err);
            return { ok: false, error: err?.message || "Admin cancel failed" };
      } finally {
            setLoading?.(false);
      }
};